import React from 'react';
import { scroller } from 'react-scroll';

const styles = {
	VERTICAL_CARDS: '1576177614499',
};

const withProductHelpers = (WrappedComponent) => {;
	class WithProductHelpers extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				isOpen: this.props.initOpen,
				cardIdList: [],
				isVertical: this.props.styleIds?.some((styleId) => styleId === styles.VERTICAL_CARDS),
			};
		}

		componentDidMount() {
			// Collapse view more on mobile
			const desktopView = window.matchMedia('(min-width: 1024px)');
			if (!desktopView.matches) {
				this.setState({ isOpen: false });
			}

			// Set card id list
			if (this.props.product) {
				this.setState({ cardIdList: [this.props.product.id] });
			} else if (this.props.products) {
				this.setState({ cardIdList: this.props.products.map((product) => product.id) });
			}
		}

		getCardIdentifier(identifier) {
			return identifier.trim().toLowerCase().replace(/\s/gm, '_');
		}

		getAEMProductInfo(currSecKey) {
			const { storeLabels } = window.storeVariables;
			const currSection = Object.keys(storeLabels).find((sec) => sec.endsWith(currSecKey));
			return storeLabels[currSection];
		}

		handleScrollTo(to, options) {
			scroller.scrollTo(to, {
				smooth: true,
				duration: 500,
				...options,
			});
		}

		handleViewDesc = () => {
			this.setState({ isOpen: !this.state.isOpen });
		};

		handlePriceChangeProxy = (sku) => {
			this.props.handlePriceChange(this.state.cardIdList, sku);
		};

		handleProdCompareProxy = () => {
			this.props.handleProdCompare(this.state.cardIdList);
		};

		handleQtyMinusProxy = () => {
			this.props.handleQtyMinus(this.state.cardIdList);
		};

		handleQtyPlusProxy = () => {
			this.props.handleQtyPlus(this.state.cardIdList);
		};

		handleQtyChangeProxy = (e) => {
			if (!e.target.value) {
				e.target.value = '0';
			}

			this.props.handleQtyChange(this.state.cardIdList, parseInt(e.target.value));
		};

		handleAddToCartProxy = (e) => {
			this.props.handleAddToCart(this.state.cardIdList);
		};

		handleRemoveErrorMsgProxy = (e) => {
			this.props.handleRemoveErrorMsg(this.state.cardIdList);
		};

		render() {
			return (
				<WrappedComponent
					isOpen={this.state.isOpen}
          isVertical={this.state.isVertical}
					cardIdList={this.state.cardIdList}
					getCardIdentifier={this.getCardIdentifier}
					getAEMProductInfo={this.getAEMProductInfo}
					handlePriceChangeProxy={this.handlePriceChangeProxy}
					handleQtyMinusProxy={this.handleQtyMinusProxy}
					handleQtyPlusProxy={this.handleQtyPlusProxy}
					handleQtyChangeProxy={this.handleQtyChangeProxy}
					handleAddToCartProxy={this.handleAddToCartProxy}
					handleRemoveErrorMsgProxy={this.handleRemoveErrorMsgProxy}
					handleProdCompareProxy={this.handleProdCompareProxy}
					handleScrollTo={this.handleScrollTo}
					handleViewDesc={this.handleViewDesc}
					{...this.props}
				/>
			);
		}
	}

	return WithProductHelpers;
};

export default withProductHelpers;
